module.exports = {
  language: 'Dutch',
  nationalityKay: 'nl-be',
  applierApplicationCenter: {
    selectCenterTip: ' '
  },
  multiplePage: {
    moreInfomation: ' ',
    recommendedServices: ' '
  },
  checkoutConfirm: {
    ordered: ' ',
    purchased: ' '
  },
  personal: {
    purgePopupContent:
      'Beklager, din ansøgning er blevet slettet på grund af sikkerhedspolitik. Du kan kontakte os, hvis du vil ansøge snart.'
  },
  login_maximum: {
    errorContent: 'Sorry dat je vandaag de maximale inlogtijden hebt bereikt, probeer het de volgende dag.'
  },
  multiselect: {
    deselect: 'Druk op enter om te verwijderen',
    select: 'Druk op enter om te selecteren',
    selected: 'Geselecteerd'
  },
  noneSelectedText: 'Selecteer alstublieft',
  something_went_wrong_please_retry: 'Er is iets fout gegaan, probeer het opnieuw.',
  valid_rediret_home_page_popup_content:
    "Er is een aanmeldingsuitzondering opgetreden. Probeert u naar de homepage van [ {country} - {center} ] te gaan om in te loggen? Zo ja, klik dan op 'Bevestigen'; zo nee, klik dan op 'Annuleren' om opnieuw te selecteren.",
  invalid_rediret_home_page_popup_content:
    'Er is een aanmeldingsuitzondering opgetreden, selecteer het land en de locatie om verder te gaan.',
  'Temporarily not available': 'Tijdelijk niet beschikbaar',
  'Coming soon': 'Binnenkort beschikbaar'
};
